import script from "./ModalTarefa.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalTarefa.vue?vue&type=script&setup=true&lang=js"

import "./ModalTarefa.vue?vue&type=style&index=0&id=f77f6bc2&scoped=true&lang=css"

import exportComponent from "G:\\Centrion\\projetos\\vue\\sisDemode\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f77f6bc2"]])

export default __exports__